import React, { useContext, useState } from 'react';
import { AppContext } from '../../../../common/context/Provider';
import { BaseConfirmModal } from '../../modals/BaseConfirmModal';
import { Props } from './selectDate';

const SelectDate = ({ isOpenModal, onClose, onSubmit }: Props) => {
    const { langResources } = useContext(AppContext);

    const [date, setDate] = useState('');

    const handlerSubmit = () => {
        if (date !== '') {
            onClose();
            onSubmit(date);
        }
    };

    return (
        <BaseConfirmModal
            isLoading={false}
            isOpen={isOpenModal}
            isShowControls={true}
            modalTitle={
                langResources['header.reports.marking.report.template.subitem']
            }
            onClose={onClose}
            onSubmit={handlerSubmit}
            textButton={langResources['reports.generate.report.button']}
        >
            <div className='modal-body '>
                <div>
                    <div className=''>
                        <label
                            htmlFor='options'
                            className='form-labe mb-2 fw-bolder'
                        >
                            {
                                langResources['update.delete.interruptions.modal'][
                                    'date.label'
                                ]
                            }
                        </label>
                        <input
                            type='date'
                            className='form-control text-dark'
                            value={date}
                            onChange={(e) => setDate(e.target.value)}
                        />
                    </div>
                </div>
            </div>
        </BaseConfirmModal>
    );
};

export default SelectDate;
